import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 768 768",
  "content": "<symbol viewBox=\"0 0 768 768\" id=\"info\"><path d=\"M384 32C188.8 32 32 188.8 32 384s156.8 352 352 352 352-156.8 352-352S579.2 32 384 32zm0 640C224 672 96 544 96 384S224 96 384 96s288 128 288 288-128 288-288 288z\" /><path d=\"M384 352c-19.2 0-32 12.8-32 32v128c0 19.2 12.8 32 32 32s32-12.8 32-32V384c0-19.2-12.8-32-32-32zM361.6 233.6c-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4c6.4 6.4 12.8 9.6 22.4 9.6s16-3.2 22.4-9.6c6.4-6.4 9.6-12.8 9.6-22.4s-3.2-16-9.6-22.4c-12.8-12.8-32-12.8-44.8 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/info.svg
// module id = XIu3
// module chunks = 1